"use strict";

var _classCallCheck = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/inherits");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Tealium = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Script = _interopRequireDefault(require("@aetn/ui-core/Html/Script"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof _WeakMap !== "function") return null;
  var cache = new _WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        _Object$defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Tealium =
/*#__PURE__*/
function (_react$Component) {
  _inherits(Tealium, _react$Component);

  function Tealium() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tealium);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tealium)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.trackEvent = function () {
      var _window;

      if ((_window = window) === null || _window === void 0 ? void 0 : _window.utg_removed) {
        window.utg_removed.view({});
      }
    };

    return _this;
  }

  _createClass(Tealium, [{
    key: "render",
    value: function render() {
      var _this$props$config = this.props.config,
          profile = _this$props$config.profile,
          tealiumEnv = _this$props$config.tealiumEnv;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_Script["default"], {
        src: "//tlum_removed/utg_removed/aenetworks/".concat(profile, "/").concat(tealiumEnv, "/utg_removed.js"),
        isLoaded: function isLoaded(window) {
          return !!(window === null || window === void 0 ? void 0 : window.utg_removed);
        }
      }));
    }
  }]);

  return Tealium;
}(_react.Component);

exports.Tealium = Tealium;
Tealium.defaultProps = {
  config: {
    tealiumEnv: 'prod'
  }
};
Tealium.propTypes = {
  config: _propTypes["default"].objectOf({
    profile: _propTypes["default"].string.isRequired,
    tealiumEnv: _propTypes["default"].string
  })
};
var _default = Tealium;
exports["default"] = _default;